export const Button = () => {
  return <button>Boop</button>;
};
